import { render, staticRenderFns } from "./EditCityField.vue?vue&type=template&id=6507735c&scoped=true&"
import script from "./EditCityField.vue?vue&type=script&lang=ts&"
export * from "./EditCityField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507735c",
  null
  
)

export default component.exports